module.exports = __webpack_public_path__ + "static/img/1.8623312d.png";